module.exports = __webpack_public_path__ + "img/zl_bg.cc08b5b7.jpg";